













export default {
  name: "webtracking-icon",
  props: {
    title: {
      type: String,
      default: "Webtracking icon"
    },
    decorative: {
      type: Boolean,
      default: false
    }
  }
}
